import { createSelector } from "reselect";
import { getBusinessMergeEvents } from "./root";

export const selectBusinessMergeEventAggridData = createSelector(
  [getBusinessMergeEvents],
  businessMergeEvents =>
    Object.values(businessMergeEvents).map(mergeEvent => ({
      mergeEvent,
    })),
);

export const getBusinessMergeEventById =
  (businessMergeEventId: string) => (state: State) =>
    getBusinessMergeEvents(state)[businessMergeEventId] || null;
